goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Logout$default");
shadow.js.shim.module$$carbon$icons_react$es$Logout$default = shadow.js.require(366, {}).default;
